export const Logo = ({ tone = "light", className = "h-9", testId = "brand-logo" }) => (
  <img
    src={tone === "light" ? "/brand/logo-light.png" : "/brand/logo-color.png"}
    alt="Happy People Factory"
    className={`w-auto select-none ${className}`}
    draggable={false}
    data-testid={testId}
  />
);

export const Mark = ({ className = "h-8 w-8" }) => (
  <img src="/brand/mark.png" alt="" aria-hidden="true" className={`object-contain ${className}`} draggable={false} />
);

const HAPPY = [
  ["H", "text-navy"],
  ["a", "text-leaf"],
  ["p", "text-sun"],
  ["p", "text-coral"],
  ["y", "text-azure"],
];

export const HappyWord = ({ className = "" }) => (
  <span className={className} aria-label="Happy">
    {HAPPY.map(([l, c], i) => (
      <span key={i} className={c} aria-hidden="true">
        {l}
      </span>
    ))}
  </span>
);
